var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"flat":""}},[(_vm.isAdmin)?_c('v-card-text',{staticClass:"pa-2"},[_vm._v("Logged in as "),_c('strong',[_vm._v("Admin")])]):_c('v-card-text',{staticClass:"pa-2"},[_vm._v("Logged in as "),_c('strong',[_vm._v(_vm._s(_vm.coach.name))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }